import React from "react";

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default function FaqHubHighlightText({ text, query }) {
  if (text == null || text === "") return null;
  const q = (query || "").trim();
  if (q.length < 2) return <>{text}</>;

  const parts = String(text).split(new RegExp(`(${escapeRegExp(q)})`, "gi"));
  return (
    <>
      {parts.map((part, i) => {
        if (part.toLowerCase() === q.toLowerCase()) {
          return (
            <mark key={i} className="bg-amber-200 text-inherit px-0.5 rounded-sm">
              {part}
            </mark>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
}
